import { render, staticRenderFns } from "./groupPerson.vue?vue&type=template&id=00a78792"
import script from "./groupPerson.vue?vue&type=script&lang=js"
export * from "./groupPerson.vue?vue&type=script&lang=js"
import style0 from "./groupPerson.vue?vue&type=style&index=0&id=00a78792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports